import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const Dashboard: React.FC = () => {
  const { currentUser } = useAuth();

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="bg-dark min-h-screen w-full flex items-center justify-center">
      <div className="text-center p-8 max-w-2xl">
        <div className="inline-flex items-center justify-center bg-dark-light px-6 py-3 rounded-full mb-8">
          <svg 
            className="w-6 h-6 mr-2 text-primary animate-spin" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
          <span className="text-white text-lg font-medium">Dashboard</span>
        </div>
        
        <h1 className="text-5xl font-bold mb-6">
          <span className="text-gray-300">Under</span>
          <span className="text-primary ml-3 animate-pulse">Construction!</span>
        </h1>
        
        <p className="text-gray-400 text-xl mb-8">
          We're working hard to bring you an amazing dashboard experience. Stay tuned for exciting updates!
        </p>
        
        <div className="inline-flex items-center justify-center bg-primary/10 px-6 py-3 rounded-lg">
          <svg 
            className="w-5 h-5 mr-2 text-primary" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
          <span className="text-primary font-medium">Coming Soon</span>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 